import { useMemo } from 'react';
import { Dimensions } from 'react-native';

import { SizeBreakpoint } from './../enums/size-breakpoint';

const useDevice = () => {
  const { width } = Dimensions.get('window');

  const isMobile = useMemo(() => {
    return width <= SizeBreakpoint.SM;
  }, [width]);

  const isTablet = useMemo(() => {
    return width > SizeBreakpoint.SM && width <= SizeBreakpoint.LG;
  }, [width]);

  const isDesktop = useMemo(() => {
    return width > SizeBreakpoint.LG;
  }, [width]);

  return {
    isMobile,
    isTablet,
    isDesktop,
  };
};

export default useDevice;
